// Index.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LandingPage from "../containers/layouts/LandingPage";
import LoginLayout from "../containers/layouts/LoginLayout";
import UserDetails from "../containers/views/UserDetails";
import InvitedUserDetails from "../containers/views/InvitedUserDetails";
import ForgotPasswordLayout from "../containers/layouts/ForgotPasswordLayout";
import AddAdminUser from "../containers/views/AddAdminUser";
import AddAppUser from "../containers/views/AddAppUser";
import MainLayout from "../containers/layouts/mainLayout";
import { useUser } from '../services/authService'; 
import { getCookie } from '../utils/cookieUtil';
import AddFaculty from "../containers/views/AddFaculty";
import AdminManagment from "../containers/views/AdminManagment";
import Registration from "../containers/views/Registration";
import Dashboard from "../containers/views/Dashboard";
import Audittrail from "../containers/views/AuditTrail";
function AppRoutes() {
  const { user} = useUser(); 

  // useEffect(() => {
  //   const cookieUser = getCookie("user");
  //   if (cookieUser !== user) {
  //     setUser(cookieUser);
  //   }
  //   console.log("Router cookie user:", cookieUser);
  // }, [user, setUser]); // Add user and setUser to dependencies

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/app" replace /> : <LoginLayout />} />
      <Route path="/" element={user ? <Navigate to="/app" replace /> : <LandingPage />} />
      <Route path="forgotpassword" element={<ForgotPasswordLayout/>} />
      <Route path="/app" element={user ? <MainLayout /> : <Navigate to="/login" replace />}>
          <Route path= "registration" element={<Registration />} />
        <Route index element={<Dashboard />} />
        <Route path="userdetails" element={<UserDetails/>} />
        <Route path="inviteduserdetails" element={<InvitedUserDetails/>} />
        <Route path="Admindetails" element={<AdminManagment/>} />
        <Route path="addadminuser" element={<AddAdminUser />} />
        <Route path="addappuser" element={<AddAppUser />} />
        <Route path="addfaculty" element={<AddFaculty/>} />
         <Route path= "audittrail" element={<  Audittrail/>} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Route>
    </Routes>
  );
}

const Index = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default Index;
